import { IToast, IToastToAdd } from '@notifications/components/Toast/Toast.type';
import { atom } from 'jotai';
import { addToast, removeToast } from './toastsStore.functions';

export const toastsAtom = atom<IToast[]>([]);

export const addToastAtom = atom(null, (get, set, toast: IToastToAdd) => {
	set(toastsAtom, addToast(get(toastsAtom), toast));
});

export const removeToastAtom = atom(null, (get, set, uuid: string) => {
	set(toastsAtom, removeToast(get(toastsAtom), uuid));
});
